module.exports = __webpack_public_path__ + "assets/media/evening.9dfcfe56.mp3";